(function() {

  'use strict';

  $('.slide-filtri').owlCarousel({
    loop:false,
    interval: 2000,
    pause: "false",
    smartSpeed: 1000,
    items: 7,
    dots: false,
    autoplay:false,
    autoplayTimeout:2000,
    autoWidth:true,
    autoplayHoverPause:false,
    nav: false,
    margin: 5,
    navText : ['<span class="glyphicon glyphicon-chevron-left" style="top: 11px;color:grey;"></span>','<span class="glyphicon glyphicon-chevron-right" style="top: 11px;color:grey;"></span>'],
    responsiveClass:true,
    responsive:{
        0:{
          items:3.1,
          margin: 0
        },
        576:{
          items:4.1
        },
        992:{
          items:5.1
        },
        1200 : {
          items: 7
        }
    }
  });

}());
